export const SIGN_IN_UP_MODE = [
  { value: "SIGN_IN", display: "Sign In" },
  { value: "SIGN_UP", display: "Sign Up" }
];

export const POINT_TRIGGER = {
  ORDER_COMPLETION: {
    display: "Order completed"
  }
};